const getFistFiling = invention => {
  return invention.patentLifecycle
    .sort((a, b) => parseFloat(a.date) - parseFloat(b.date))
    .find(item => item["phase"] == "provisional_filing").date;
};
export default getFistFiling;
